<!--
  --
  -- 日時を表示するシートコンポーネント
  --
  -->
<template>
  <v-sheet
    rounded
    :outlined="outlined"
    :color="color"
  >
    <v-row no-gutters style="padding-top: 6px; padding-bottom: 6px;">
      <v-col cols="12" class="text-center">
        <span class="text-subtitle-1 font-weight-bold primary--text">{{time | timeformat('j')}}</span>
        <small class="text--secondary"> 日 </small>
        <span class="text-subtitle-1 font-weight-bold primary--text">{{time | timeformat('H:i')}}</span>
      </v-col>
      <v-col cols="12" class="text-center">
        <small>{{time | timeformat('Y年n月')}}</small>
        <small class="ml-2">{{time | timeformat('(x)')}}</small>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'CTimeSheet',
  props: {
    time: {
      type: [Date, String],
      required: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    }
  }
}
</script>
